import React, { useState, useMemo } from "react";
import { connect } from "react-redux";
import { Card, Row, Col, Container, Input } from "reactstrap";
import Arrow_DownWords from "../../../../../../../../../../../../src/designUtils/Logo/Arrow_DownWords.svg";
import Vector_Arrow from "../../../../../../../../../../../../src/designUtils/Logo/Vector_Arrow.svg";
import ProductsPagination from "../../../../../../../../../../Components/Pagination/ProductsPagination";

function AssetsProductList(props) {
  const [selectedParent, setSelectedParent] = useState(null);
  const [isActive, setIsActive] = useState();
  const [searchInput, setSearchInput] = useState(""); 
  const [downArrow, setDownArrow] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);

  const pageSize = 10;
  const startIndex = currentPage * pageSize;
  const endIndex = startIndex + pageSize;

  const handlePageChange = (page) => {
    if (page >= 0 && page < totalPages) {
      setCurrentPage(page);
    }
  };

  const handleSearchChange = (e) => {
    setSearchInput(e.target.value);
    setCurrentPage(0);  // Reset to the first page when searching
  };

  // Group child products by their parent ASIN
  const groupedChildren = useMemo(() => {
    return props.childProducts.reduce((acc, child) => {
      const parentId = child.parentProduct;
      if (!acc[parentId]) {
        acc[parentId] = [];
      }
      acc[parentId].push(child);
      return acc;
    }, {});
  }, [props.childProducts]);

  // Handle click on parent product to toggle expansion
  const handleParentClick = (parentAsin) => {
    // Toggle the selected parent and arrow direction based on the current state
    setSelectedParent((prevSelected) => {
      if (prevSelected === parentAsin) {
        setIsActive(null); 
        setDownArrow(false); 
        return null; 
      } else {
        // If a different parent is clicked, expand it and point the arrow down
        setIsActive(parentAsin); 
        setDownArrow(true); 
        return parentAsin; 
      }
    });
  };

   // Filter parent products based on search input
   const filterParentProductsWithChildren = useMemo(() => {
    return props.parentProducts.filter((parent) => {
      // Check if the parent matches the search input
      const parentMatches =
        parent.asin.toLowerCase().includes(searchInput.toLowerCase()) ||
        parent.productTitle.toLowerCase().includes(searchInput.toLowerCase());
  
      // Check if any of the children match the search input
      const childrenMatch =
        groupedChildren[parent.asin]
          ? groupedChildren[parent.asin].some(
              (child) =>
                child.asin.toLowerCase().includes(searchInput.toLowerCase()) ||
                child.productTitle.toLowerCase().includes(searchInput.toLowerCase())
            )
          : false;
  
      return parentMatches || childrenMatch;
    });
  }, [searchInput, props.parentProducts, groupedChildren]);
  

  // Filter orphan products based on search input, and exclude child products
  const filterOrphanProducts = useMemo(() => {
    return props.orphanProducts.filter(
      (orphan) =>
        !props.childProducts.some((child) => child.asin === orphan.asin) && // Exclude orphan products that are already child products
        (orphan.asin.toLowerCase().includes(searchInput.toLowerCase()) ||
          orphan.productTitle.toLowerCase().includes(searchInput.toLowerCase()))
    );
  }, [searchInput, props.orphanProducts, props.childProducts]);

  const filteredParentProducts = filterParentProductsWithChildren;
  const filteredOrphanProducts = filterOrphanProducts;

  // Combine parent and orphan products into one list (for pagination purposes)
  const combinedProducts = [
    ...filteredParentProducts.map((parent) => ({
      ...parent,
      isParent: true,
      children: groupedChildren[parent.asin] || [],
    })),
    ...filteredOrphanProducts.map((orphan) => ({
      ...orphan,
      isParent: false,
      children: [],
    })),
  ];

  // Apply pagination to the combined list of parent and orphan products
  const paginatedCombinedProducts = combinedProducts.slice(startIndex, endIndex);
  // const totalDisplayedProducts = combinedProducts.length;
  const totalChildProducts = filteredParentProducts.reduce((acc, parent) => {
    const children = groupedChildren[parent.asin] || [];
    return acc + children.length;
  }, 0);
  
  const totalDisplayedProducts = totalChildProducts + filteredOrphanProducts.length;
  
  const totalFilteredProducts = combinedProducts.length;
  const totalPages = Math.ceil(totalDisplayedProducts / pageSize);
  return (
    <Container>
      <Row>
      <Col md={12} className="mt-5 mb-3 d-flex justify-content-end">
        <Input
            type="text"
            className="w-25 mr-3"
            placeholder="Search by ASIN or Product Title"
            value={searchInput}
            onChange={handleSearchChange}
          />
          <ProductsPagination
            currentPage={currentPage}
            totalRecords={totalFilteredProducts}
            pageSize={pageSize}
            onPageChange={handlePageChange}
          />
        </Col>

        {/* Display paginated combined products (parent and orphan products) */}
        {paginatedCombinedProducts.map((product) => {
          const variantCount = (groupedChildren[product.asin] && groupedChildren[product.asin].length) || 0;
          const isChildProduct =
            product.parentProduct !== "orphan" && product.parentProduct !== null;

          // For parent products
          if (isChildProduct) {
            return (
              <Col md={12} key={product.asin}>
                {totalDisplayedProducts > 300 ? (
                <Card
                  className={`mb-3 card-hover-container ${product.asin === isActive ? "selected-assets-parent-card" : ""}`}
                  onClick={() =>{ handleParentClick(product.asin); }}
                  style={{ cursor: "pointer" }}
                >
                  <Row className="p-3 product-hover-wrapper">
                    <Col md={1} className="product-img">
                      <div className="image-container">
                        <img
                          src={product.itemImage}
                          className="product-img-display"
                          height={60}
                          width={80}
                          alt="Parent Product"
                        />
                      </div>
                    </Col>
                    <Col md={11}>
                      <Row>
                        <Col md={11} className="pl-3 pr-0 product-title-container">
                        <div className="d-flex align-items-center">
                          <p className="mb-0 product-title-text">
                          <span className="badge-pill assets-products-count mr-1">{variantCount} variant{variantCount !== 1 ? "s" : ""}</span>
                            <b>{product.productTitle}</b>
                          </p>
                          </div>
                          <div className=" d-flex align-items-center mt-1">
                          <p className="mb-0 mr-2">ASIN: {product.asin}</p>
                          {/* {
                                product.statsPropertiesList &&
                                product.statsPropertiesList.map((statsProp, index) => (
                                  <span key={index} className="assets-pill media-pill mr-2">
                                    {statsProp.displayText}
                                    <span className="pill-count-circle mr-2">
                                      {statsProp.asset_count}
                                    </span>
                                  </span>
                                ))
                              } */}
                             {
                          product.statsPropertiesList &&
                          product.statsPropertiesList.map((statsProp, index) => {
                            if ((statsProp.displayText === "Media" || statsProp.displayText === "Documents")&&statsProp.asset_count !== 0) {
                              return (
                                <span key={index} className="assets-pill media-pill mr-2 ml-2">
                                  {statsProp.displayText}
                                  <span className="pill-count-circle mr-2 ml-1">
                                    {statsProp.asset_count}
                                  </span>
                                </span>
                              );
                            }
                            return null;
                          })
                            }  
                          </div>
                        </Col>
                        
                        <Col md={1} className="d-flex justify-content-end" style={{ left: '90px' }}>
                          {product.asin === isActive && downArrow ? (
                            <img style={{ height: '27px', width: '25px' }} src={Arrow_DownWords} />
                          ) : (
                            <img style={{ height: '25px',width: '20px' }} src={Vector_Arrow} />
                          )}
                        </Col>
                      </Row>
                    </Col>
                  </Row>

                  {/* Render child products if parent is selected */}
                  {selectedParent === product.asin &&
                    product.children.map((child) => (
                      <Card
                        key={child.asin}
                        className={`child-card mx-3 my-2 p-2 card-hover-container`}
                        onClick={() => props.setProductDetails(child)}
                      >
                        <Row className="p-3 mr-5 product-hover-wrapper">
                          <Col md={1} className="product-img">
                            <div className="image-container">
                              <img
                                src={child.itemImage}
                                height={60}
                                width={60}
                                className="product-img-display"
                                alt="Child Product"
                              />
                            </div>
                          </Col>
                          <Col md={11} className="mr-5 pl-3 pr-0 product-title-container">
                            <p className="mb-0">
                              <b>{child.productTitle}</b>
                            </p>
                            <div className="d-flex align-items-center mt-1">
                              <p className="mb-0 mr-2">ASIN: {child.asin}</p>
                              {/* {
                                    product.statsPropertiesList && product.statsPropertiesList.map((statsProp) => (
                                      <span className="child-assets-pill child-media-pill mr-2">
                                        {statsProp.displayText} <span className="child-pill-count-circle">{statsProp.asset_count}</span>
                                      </span>
                                    ))

                                  } */}
                               {
                          child.statsPropertiesList &&
                          child.statsPropertiesList.map((statsProp) => {
                            if ((statsProp.displayText === "Media" || statsProp.displayText === "Documents")&&statsProp.asset_count !== 0) {
                              return (
                                <span className="child-assets-pill child-media-pill mr-2 ml-2">
                                  {statsProp.displayText}
                                  <span className="child-pill-count-circle mr-2 ml-1">
                                    {statsProp.asset_count}
                                  </span>
                                </span>
                              );
                            }
                            return null;
                          })
                            }    
                              </div>
                          </Col>
                        </Row>
                      </Card>
                    ))}
                </Card>
                ) : (
                  <Card
                  className={`mb-3 ${product.asin === isActive ? "selected-assets-parent-card" : ""}`}
                  onClick={() => { handleParentClick(product.asin);  }}
                  style={{ cursor: "pointer" }}
                >
                  <Row className="p-3">
                    <Col md={1}>
                      <img
                        src={product.itemImage}
                        height={70}
                        width={80}
                        alt="Parent Product"
                      />
                    </Col>
                    <Col md={11} className="pl-3 pr-0">
                      <Row>
                        <Col md={11}>
                        <div className="d-flex align-items-center">
                        <p className="mb-0 product-title-text">
                        <span className="badge-pill assets-products-count mr-1">{variantCount} variant{variantCount !== 1 ? "s" : ""}</span>
                          <b>{product.productTitle}</b></p>
                        </div>
                        <div className="d-flex align-items-center mt-1">
                        <p className="mb-0 mr-2">ASIN: {product.asin}</p>
                        {/* {
                                product.statsPropertiesList &&
                                product.statsPropertiesList.map((statsProp, index) => (
                                  <span key={index} className="assets-pill media-pill mr-2">
                                     
                                    {statsProp.displayText}
                                    <span className="pill-count-circle mr-2">
                                      {statsProp.asset_count}
                                    </span>
                                  </span>
                                ))
                              } */}
                                {
                          product.statsPropertiesList &&
                          product.statsPropertiesList.map((statsProp, index) => {
                            if ((statsProp.displayText === "Media" || statsProp.displayText === "Documents")&&statsProp.asset_count !== 0) {
                              return (
                                <span key={index} className="assets-pill media-pill mr-2 ml-2">
                                  {statsProp.displayText}
                                  <span className="pill-count-circle mr-2 ml-1">
                                    {statsProp.asset_count}
                                  </span>
                                </span>
                              );
                            }
                            return null;
                          })
                            } 
                        </div>
                        </Col>
                        <Col md={1} className="d-flex justify-content-start">
                          {product.asin === isActive && downArrow ? (
                            <img style={{ height: '27px', width: '25px' }} src={Arrow_DownWords} />
                          ) : (
                            <img style={{ height: '25px',width: '20px' }} src={Vector_Arrow} />
                          )}
                        </Col>
                      </Row>
                    </Col>
                  </Row>
      
                  {selectedParent === product.asin &&
                    groupedChildren[product.asin] &&
                    groupedChildren[product.asin]
                      .filter(
                        (child) =>
                          child.asin.toLowerCase().includes(searchInput.toLowerCase()) ||
                          child.productTitle.toLowerCase().includes(searchInput.toLowerCase())
                      )
                      .map((child) => (
                        <Card
                          key={child.id}
                          className={`child-card mx-3 my-2 p-2`}
                          onClick={() => props.setProductDetails(child)}
                        >
                          <Row className="p-3 mr-5">
                            <Col md={1}>
                              <img
                                src={child.itemImage}
                                height={60}
                                width={60}
                                alt="Child Product"
                              />
                            </Col>
                            <Col md={11}>
                            
                              <p className="mb-0"><b>{child.productTitle}</b></p>
                              <div className="d-flex align-items-center mt-1">
                              <p className="mb-0 mr-2">ASIN: {child.asin}</p>
                              {/* {
                                    child.statsPropertiesList && child.statsPropertiesList.map((statsPropChild) => (
                                      <span className="child-assets-pill child-media-pill mr-2">
                                        {statsPropChild.displayText} <span className="child-pill-count-circle">{statsPropChild.asset_count}</span>
                                      </span>
                                    ))

                                  } */}
                              {
                          child.statsPropertiesList &&
                          child.statsPropertiesList.map((statsPropChild) => {
                            if ((statsPropChild.displayText === "Media" || statsPropChild.displayText === "Documents")&&statsPropChild.asset_count !== 0) {
                              return (
                                <span className="child-assets-pill child-media-pill mr-2 ml-2">
                                  {statsPropChild.displayText}
                                  <span className="child-pill-count-circle mr-2 ml-1">
                                    {statsPropChild.asset_count}
                                  </span>
                                </span>
                              );
                            }
                            return null;
                          })
                            } 
                              </div>
                            </Col>
                          </Row>
                        </Card>
                      ))}
                </Card>
              )}
              </Col>
            );
          } else {
            // For orphan products (those with no parent)
            return (
              <Col md={12} key={product.asin}>
                {totalDisplayedProducts > 300 ? (
                <Card
                  className={`mb-3 card-hover-container`}
                  onClick={() => props.setProductDetails(product)}
                >
                  <Row className="p-3 mr-5 product-hover-wrapper">
                    <Col md={1} className="product-img">
                      <div className="image-container">
                        <img
                          src={product.itemImage}
                          className="product-img-display"
                          height={70}
                          width={70}
                          alt="Orphan Product"
                        />
                      </div>
                    </Col>
                    <Col md={11} className="pl-3 pr-0 product-title-container">
                    
                      <p className="mb-0">
                        <b>{product.productTitle}</b>
                      </p>
                      <div className="d-flex align-items-center mt-1">
                      <p className="mb-0 mr-2">ASIN: {product.asin}</p>
                      {/* {
                            product.statsPropertiesList && product.statsPropertiesList.map((statsProp) => (
                              <span className="child-assets-pill child-media-pill mr-2">
                                
                                {statsProp.displayText} <span className="child-pill-count-circle">{statsProp.asset_count}</span>
                              </span>
                            ))

                          } */}
                          {
                          product.statsPropertiesList &&
                          product.statsPropertiesList.map((statsProp, index) => {
                            if ((statsProp.displayText === "Media" || statsProp.displayText === "Documents")&&statsProp.asset_count !== 0) {
                              return (
                                <span key={index} className="child-assets-pill child-media-pill mr-2 ml-2">
                                  {statsProp.displayText}
                                  <span className="child-pill-count-circle mr-2 ml-1">
                                    {statsProp.asset_count}
                                  </span>
                                </span>
                              );
                            }
                            return null;
                          })
                            } 
                            </div>
                         
                    </Col>
                  </Row>
                </Card>
                ) : (
                  <Card
                    className={`mb-3`}
                    onClick={() => props.setProductDetails(product)}
                  >
                    <Row className="p-3 mr-5">
                      <Col md={1}>
                        <img
                          src={product.itemImage}
                          height={70}
                          width={80}
                          alt="Orphan Product"
                        />
                      </Col>
                      <Col md={11} className="pl-3 pr-0">
                     
                        <p className="mb-0"><b>{product.productTitle}</b></p>
                        <div className="d-flex align-items-center mt-1">
                        <p className="mb-0 mr-2">ASIN: {product.asin}</p>
                        {/* {
                            product.statsPropertiesList && product.statsPropertiesList.map((statsProp) => (
                              <span className="child-assets-pill child-media-pill mr-2">
                                
                                {statsProp.displayText} <span className="child-pill-count-circle">{statsProp.asset_count}</span>
                              </span>
                            ))

                          } */}
                            {
                          product.statsPropertiesList &&
                          product.statsPropertiesList.map((statsProp) => {
                            if ((statsProp.displayText === "Media" || statsProp.displayText === "Documents")&&statsProp.asset_count !== 0) {
                              return (
                                <span className="child-assets-pill child-media-pill mr-2 ml-2">
                                  {statsProp.displayText}
                                  <span className="child-pill-count-circle mr-2 ml-1">
                                    {statsProp.asset_count}
                                  </span>
                                </span>
                              );
                            }
                            return null;
                          })
                            }
                        </div>
                      </Col>
                    </Row>
                  </Card>
                )}
              </Col>
            );
          }
        })}
      </Row>
    </Container>
  );
}

const mapStateToProps = (state) => {
  return {
    token: state.loggedUser.token,
    accessLevel: state.loggedUser.accessLevel,
    status: state.loggedUser.status,
    storeOverview: state.accountOverview.store.storeOverview,
    childProducts: state.accountOverview.store.childProducts,
    adProfiles: state.accountOverview.landing.adProfiles,
    parentProducts: state.accountOverview.store.parentProducts,
    orphanProducts: state.accountOverview.store.orphanProducts,
  };
};

export default connect(mapStateToProps)(AssetsProductList);
